module.exports = __webpack_public_path__ + "static/media/wbtcLogo.c5710a84.svg";